import { generateApiAction, RESPONSETYPE } from '../Generator'
import Types from '../Types'
import { reorderCategory } from '../Api'

export default generateApiAction({
  baseType: Types.CATEGORIES.REORDER,
  api: reorderCategory,
  responseType: RESPONSETYPE.EMPTY
})



// WEBPACK FOOTER //
// ./src/actions/categories/ReorderAction.js